export const enum LandingNames {
	RBO = 'rbo',
	RKO = 'rko',
	SELF_EMPLOYED = 'self-employed',
	ACQUIRING = 'acquiring',
	SALARY_PROJECT = 'salary_project',
	OKOLO = 'okolo',
	FOODTIME = 'foodtime',
	RBO_CARD = 'rbo_card',
	RKO_CARD = 'rko_card',
	FRANCHISE = 'franchise',
	RBO_CARD_MULTI = 'rbo_card_multi',
	FRANCHISE_CARD = 'franchise_card',
}
